export default __webpack_public_path__ + "static/media/invite_back.fe032007.jpg";